import baseComponent from "@/scripts/baseComponent";
import authApi from "@/api/auth";
import api from '@/api/baseApi';
// Constant
import { SETTINGS_USER_API } from "@/constant/apiSettings";
import commonActionHandle from "@/commonActionHandle";
import { GPURENTAL_STATUS_CODE } from "@/constant/config";
import VueRecaptcha from 'vue-recaptcha';
import CodeInput from "@/views/auth/component/CustomCodeInput.vue";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
const fpPromise = FingerprintJS.load();
const homepage = process.env.VUE_APP_HOMEPAGE;
const enableRecaptcha = (process.env.VUE_APP_ENABLED_RECAPTCHA == 'true');
const localStorageDeviceIdKey = 'deviceIdentificationId';
export default {
    props: {
        location: {
            type: String,
            default: null
        },
    },
    extends: baseComponent,
    components: { VueRecaptcha, CodeInput },
    data() {
        return {
            homepage: homepage,
            VUE_APP_HOMEPAGE_NOSCHEMA: process.env.VUE_APP_HOMEPAGE_NOSCHEMA,
            isLoading: false,
            enabledRecaptcha: enableRecaptcha,
            deviceIdentificationId: null,
            twoFactorData: {
                isTwoFactorLoading: false,
                centerDialogVisible: false,
                cancelPINDialogAction: null,
                submitPINDialogAction: null,
                pinInputCompleted: false,
                pinInputValue: '',
                pinSubmitError: null,
            },
            loginForm: {
                appCode: this.$lang.common.appCode,
                username: "",
                password: "",
                recaptchaToken: "",
                rememberMe: false,
                deviceInformation: '',
            },
            rules: {
                username: [
                    {
                        required: true,
                        message: this.$t('login.validationRequiredUsername'),
                        trigger: "blur"
                    }
                ],
                password: [
                    {
                        required: true,
                        message: this.$t('login.validationRequiredPassword'),
                        trigger: "blur"
                    }
                ],
            },
            currertEmail: '',
        };
    },
    computed: {
        canLogin() {
            return ((!this.enabledRecaptcha || this.loginForm.recaptchaToken !== '') && this.loginForm.username !== '' && this.loginForm.password !== '');
        },
        canLoginWithTwoFactor() {
            return ((!this.enabledRecaptcha || this.loginForm.recaptchaToken !== '') && this.twoFactorData.pinInputValue.length === 6);
        },
        finalDeviceIdentificationId(){
            if(this.deviceIdentificationId && this.deviceIdentificationId !== null) return this.deviceIdentificationId;

            let dIIStorage = localStorage.getItem(localStorageDeviceIdKey);
            if(dIIStorage && dIIStorage !== null) return dIIStorage;

            return null;
        },
    },
    mounted() {
        this.getVisitorBrowerId();
    },
    methods: {
        getVisitorBrowerId(){   
            this.isLoading = true;  
            fpPromise.then((fp) => {
                fp.get()
                .then((result) => {
                    console.log(result.visitorId);
                    this.deviceIdentificationId = result.visitorId;
                    this.isLoading = false;
                    localStorage.setItem(localStorageDeviceIdKey, result.visitorId);
                })
                .catch(error => {
                    console.error('fp get', error);
                    this.isLoading = false;
                });
            })
            .catch(error => {
                console.error('fpPromise', error);
                this.isLoading = false;
            });
        },
        precheckTwoFactorAuth() {
            api.baseRequest(SETTINGS_USER_API.PRE_LOGIN_CHECK_TWO_FACTOR_AUTH, this.loginForm)
                .then((res) => {
                    if (res.data) {
                        this.isLoading = false;
                        this.showPinCodeInput(() => {
                            this.resetAll();
                        }, () => {
                            this.isLoading = true;
                            this.loginForm.twoFactorAuthentionCode = this.twoFactorData.pinInputValue;
                            this.performAuthencate();
                        });
                    }
                    else {
                        this.performAuthencate();
                    }
                })
                .catch(error => {
                    console.error(error);
                    this.isLoading = false;
                });
        },

        // Submit form login 
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.isLoading = true;
                    this.loginForm.deviceInformation = JSON.stringify(this.getInformationClient());
                    this.loginForm.deviceIdentificationId = this.finalDeviceIdentificationId;
                    try {
                        this.matomoLog('LoginPage', `Click`, 'Login');
                    } catch { }

                    this.loginProcess();
                } else {
                    return false;
                }
            });
        },

        loginProcess() {
            authApi
                .authLogin(this.loginForm)
                .then(res => {
                    try {
                        switch (res.errorCode) {
                            case GPURENTAL_STATUS_CODE.LoginCookie_Success:
                                localStorage.setItem('userId', res.data.userId);
                                location.href = `/dashboard?v=${Date.now()}`;
                                break;
                            default:
                                this.resetRecaptcha();
                                commonActionHandle.showCustomWarning(
                                    'Login failed ...',
                                    "Username or password incorrect.",
                                    () => { },
                                    () => { },
                                    '',
                                    '',
                                    false,
                                );
                                this.isLoading = false;
                                break;
                        }
                    } catch (error) {
                        this.resetRecaptcha();
                        commonActionHandle.showCustomWarning(
                            'Login failed ...',
                            "An unknown error. Please press Ctrl+F5 (Windows, Ubuntu) or Command+R (Mac OS) then try again. If the same error persists, please contact iRender customer care.",
                            () => { },
                            () => { },
                            '',
                            '',
                            false,
                        );
                        this.isLoading = false;
                    }
                })
                .catch(error => {
                    setTimeout(() => {
                        try {
                            this.isLoading = false;
                            if (error.name === 'Error') {
                                this.resetRecaptcha();
                                this.$store.dispatch("common/showCommonError", error);
                            } else {
                                this.currertEmail = error.data;
                                switch (error.errorCode) {
                                    case GPURENTAL_STATUS_CODE.LoginCookie_UserBlocked:
                                        commonActionHandle.showCustomError(
                                            'Login failed ...',
                                            'Sorry! Your account has been locked. Please contact support if you have any questions',
                                            () => { },
                                            () => { },
                                            '',
                                            '',
                                            false,
                                        );
                                        this.resetAll();
                                        break;
                                    case GPURENTAL_STATUS_CODE.LoginCookie_NonActivate:
                                        commonActionHandle.showCustomWarning(
                                            'Login failed ...',
                                            'Your account has not been activated. Please activate your account according to the instructions sent to the email address you registered',
                                            this.reSendEmail,
                                            () => { },
                                            'Re-send email',
                                            '',
                                        );
                                        this.resetAll();
                                        break;
                                    case GPURENTAL_STATUS_CODE.LoginCookie_UserDisabled:
                                        commonActionHandle.showCustomWarning(
                                            'Login failed ...',
                                            'Your account is not operating for more than 6 months. To ensure safety, we have put your account into hibernation.',
                                            this.reActivateAccount,
                                            () => { },
                                            'Reactivate your account',
                                            '',
                                        );
                                        this.resetAll();
                                        break;
                                    case GPURENTAL_STATUS_CODE.LoginCookie_RecaptchaVerifyFailed:
                                        commonActionHandle.showCustomWarning(
                                            'Recaptcha verify failed...',
                                            error.message,
                                            () => { },
                                            () => { },
                                            '',
                                            '',
                                            false,
                                        );
                                        this.resetAll();
                                        break;
                                    case GPURENTAL_STATUS_CODE.LoginCookie_CheckingTwoFactorAuthentication:
                                        this.isLoading = false;
                                        this.showPinCodeInput(
                                            () => { this.resetAll(); },
                                            () => {
                                                this.isLoading = true;
                                                this.loginForm.twoFactorAuthentionCode = this.twoFactorData.pinInputValue;
                                                this.loginProcess();
                                            });
                                        break;
                                    case GPURENTAL_STATUS_CODE.LoginCookie_TwoFactorAuthPinInValid:
                                        commonActionHandle.showCustomWarning(
                                            'PIN code invalid...',
                                            'The PIN code you entered is incorrect.',
                                            () => { this.resetAll(); },
                                            () => { },
                                            '',
                                            '',
                                            false,
                                        );
                                        break;
                                    default:
                                        commonActionHandle.showCustomWarning(
                                            'Login failed ...',
                                            "Username or password incorrect.",
                                            () => { },
                                            () => { },
                                            '',
                                            '',
                                            false,
                                        );
                                        this.resetAll();
                                        break;
                                }
                            }
                        } catch (error) {
                            commonActionHandle.showCustomWarning(
                                'Login failed ...',
                                "An unknown error. Please press Ctrl+F5 (Windows, Ubuntu) or Command+R (Mac OS) then try again. If the same error persists, please contact iRender customer care.",
                                () => { },
                                () => { },
                                '',
                                '',
                                false,
                            );
                            this.resetAll();
                        }
                    }, 1000);
                    this.resetRecaptcha();
                });
        },

        reActivateAccount() {
            this.isLoading = true;
            let request = {
                user: this.loginForm.username,
                deviceInformation: JSON.stringify(this.getInformationClient()),
            }
            authApi.reActivateAccount(request)
                .then(res => {
                    commonActionHandle.showCustomSuccess(
                        'Success !',
                        "Account activation email has been successfully re-sent !",
                    );
                    this.isLoading = false;
                })
                .catch(error => {
                    setTimeout(() => {
                        try {
                            this.isLoading = false;
                            if (error.name === 'Error') {
                                this.$store.dispatch("common/showCommonError", error);
                            } else {
                                switch (error.errorCode) {
                                    default:
                                        this.$store.dispatch("common/showUnkownError", error, 'Send email failed ...');
                                        break;
                                }
                            }
                        } catch (error) {
                            this.$store.dispatch("common/showUnkownError", error, 'Send email failed ...');
                        }
                    }, 1000);
                });
        },

        reSendEmail() {
            this.isLoading = true;
            let request = {
                user: this.loginForm.username,
                deviceInformation: JSON.stringify(this.getInformationClient()),
            }
            authApi.reSendEmail(request)
                .then(res => {
                    try {
                        switch (res.errorCode) {
                            case GPURENTAL_STATUS_CODE.ResendActiveEmail_Success:
                                commonActionHandle.showCustomSuccess(
                                    'Success !',
                                    "Account activation email has been successfully re-sent !",
                                );
                                break;
                            default:
                                this.$store.dispatch("common/showUnkownError", res, 'Send email failed ...');
                                break;
                        }
                    } catch (error) {
                        this.$store.dispatch("common/showUnkownError", error, 'Send email failed ...');
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    setTimeout(() => {
                        try {
                            this.isLoading = false;
                            if (error.name === 'Error') {
                                this.$store.dispatch("common/showCommonError", error);
                            } else {
                                switch (error.errorCode) {
                                    case GPURENTAL_STATUS_CODE.ResendActiveEmail_AccountActivated:
                                        commonActionHandle.showCustomError(
                                            'Send email failed ...',
                                            error.message
                                        );
                                        break;
                                    default:
                                        this.$store.dispatch("common/showUnkownError", error, 'Send email failed ...');
                                        break;
                                }
                            }
                        } catch (error) {
                            this.$store.dispatch("common/showUnkownError", error, 'Send email failed ...');
                        }
                    }, 1000);
                });
        },
        verifyRecaptcha(response) {
            //console.log("verifyRecaptcha", response);
            this.$set(this.loginForm, "recaptchaToken", response);
        },
        expiredRecaptcha() {
            if (this.enabledRecaptcha) {
                this.$set(this.loginForm, "recaptchaToken", "");
                if (this.$refs.recaptchaComp) this.$refs.recaptchaComp.reset();
                this.enabledRecaptcha = false;
                this.enabledRecaptcha = process.env.VUE_APP_ENABLED_RECAPTCHA;
            }
        },
        renderRecaptcha(id) {
            //console.log("renderRecaptcha", id);
        },
        errorRecaptcha() {
            //console.log("errorRecaptcha");
        },
        resetRecaptcha() {
            console.log('resetCapcha')
            if (this.enabledRecaptcha) {
                this.$set(this.loginForm, "recaptchaToken", "");
                if (this.$refs.recaptchaComp) this.$refs.recaptchaComp.reset();
                this.enabledRecaptcha = false;
                this.enabledRecaptcha = process.env.VUE_APP_ENABLED_RECAPTCHA;
            }
        },
        // Open component view
        openComponentView(componentName) {
            this.$emit("openComponentView", componentName);
            this.matomoLog('LoginPage', `Click`, componentName);
        },


        showPinCodeInput(cancelAction, confirmAction) {
            this.twoFactorData.cancelPINDialogAction = cancelAction;
            this.twoFactorData.submitPINDialogAction = confirmAction;
            this.twoFactorData.centerDialogVisible = true;
            this.$nextTick(() => {
                $('.PIN-CODE .react-code-input > input:first-child').focus();
            });
        },
        onPINChange(v) {
            if (v.length < 6) {
                this.twoFactorData.pinInputCompleted = false;
                this.twoFactorData.pinInputValue = v;
            }
        },
        onPINComplete(v) {
            if (v.length === 6) {
                this.twoFactorData.pinInputCompleted = true;
                this.twoFactorData.pinInputValue = v;
            }
        },
        resetAll() {
            this.loginForm.twoFactorAuthentionCode = null;

            this.twoFactorData.pinInputCompleted = false;
            this.twoFactorData.pinInputValue = '';
            this.twoFactorData.centerDialogVisible = false;
            this.twoFactorData.pinSubmitError = null;
            $('.PIN-CODE .react-code-input > input').val('');
            $('.PIN-CODE .react-code-input > input:first-child').focus();
            this.twoFactorData.isTwoFactorLoading = false;
        }
    }
};